import script from "./RealizarBaja.vue?vue&type=script&setup=true&lang=js"
export * from "./RealizarBaja.vue?vue&type=script&setup=true&lang=js"

import "./RealizarBaja.vue?vue&type=style&index=0&id=eabeb598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eabeb598"]])

export default __exports__